<template>
  <div>
    <div v-if="bannerData" id="PersonaliseModal">
      <h2 class="title" v-html="decodeData(bannerData.title)">
      </h2>
      <p class="paragraph">
         {{ bannerData.description }}
      </p>
      <div class="list">
        <button
          v-for="(tag, i) in bannerData.items"
          :key="i"
          class="list-item"
          :class="{ active: selectedTag && selectedTag.title === tag.title }"
          @click="selectTag(tag)"
        >
          {{ tag.title }}
        </button>
      </div>
      <div class="checkbox-container">
        <input type="checkbox" id="checkbox" class="checkbox" />
        <label for="checkbox" class="checkbox-label text">
          Don't show this window again.
        </label>
      </div>
      <button class="button" @click="closeModal">Take me to the homepage</button>
    </div>
    <div v-else>Loading</div>
  </div>
</template>

<script>
import EventBus from "@/helpers/eventbus";

export default {
  name: "PersonaliseModal",
  props: ["bannerData"],
  data() {
    return {
      tags: [
        "Mental Health",
        "Fitness",
        "Nutrition",
        "Meditation",
        "Health & Wellbeing",
        "Cancer Care"
      ],
      selectedTag: null,
    };
  },
  methods: {
    closeModal() {
      this.$bvModal.hide("personalise-modal");
    },
    selectTag(tag) {
      this.selectedTag = tag;
      EventBus.$emit("selectHomeFiltersTag", {
        id: this.selectedTag.id,
        tag: this.selectedTag.title
      });
    },
    decodeData(data) {
      try {
        return atob(data);
      } catch (error) {
        return data;
      }
    }
  }
};
</script>

<style lang="less">
#PersonaliseModal {
  color: #192550;
  padding: 40px;
  text-align: center;

  .title {
    font-family: "Raptor V3 Black";
    font-size: 3.2rem;
    text-align: center;
    color: #192550;
    font-weight: 900;
    margin-bottom: 24px;
  }

  .header-accent {
    color: #604AFF;
  }

  .paragraph {
    font-size: 1.8rem;
    margin-bottom: 40px;
  }

  .list {
    display: flex;
    max-width: 450px;
    flex-wrap: wrap;
    gap: 12px;
    margin: 0 auto 44px;
  }

  .list-item {
    flex: 1 1 30%;
    max-width: 30%;
    min-height: 96px;
    padding: 28px 20px;
    border: 3px solid #e8e8e8;
    border-radius: 4px;
    color: #84818a;
    font-weight: 700;
    background-color: transparent;

    &:hover,
    &.active {
      border: 3px solid #604AFF;
      color: #604AFF;
    }
  }

  .checkbox {
    cursor: pointer;
    width: 28px;
    height: 28px;
    color: #fff;
    font-family: "DMSans";

    &:before {
      content: "";
      display: block;
      width: 28px;
      color: #fff;
      background-color: #fff;
      border: 3px solid #604AFF;
      height: 28px;
    }

    &:checked:before {
      content: "✔";
      font-size: 2rem;
      line-height: 2rem;
      padding: 3px;
      color: #fff;
      background-color: #604AFF;
    }
  }

  .checkbox-label{
    cursor: pointer;
    margin: 0;
  }

  .text {
    color: #000000;
    font-size: 20px;
  }

  .checkbox-container {
    display: flex;
    gap: 14px;
    justify-content: center;
    align-items: center;
    margin-bottom: 48px;
  }

  .button {
    background-color: #604AFF;
    border-radius: 5px;
    padding: 12px 20px;
    color: #ffffff;
    font-size: 16px;
    border: none;
    margin-bottom: 40px;
    font-family: "Raptor V3 Black";
  }

  .link {
    color: #604AFF;
    text-decoration: underline;
    font-family: "DMSans Bold";
  }
}
</style>
